import React, {useState} from 'react';
import {withTranslation} from 'react-i18next';
import {StackedSpacer} from '../../shared/custom-features/spacer/StackedSpacer';
import {Card} from '../../shared/elements/card/Card';
import {LineSpacer} from '../../shared/custom-features/spacer/LineSpacer';
import {FormSelect} from '../../shared/form/form-control/FormSelect';
import {Btn} from '../../shared/elements/btn/Btn';
import errorHandler from '../../util/errorHandler';
import {saveAs} from 'file-saver';
import moment from 'moment';
import {downloadOvertime} from './endpoints.js';
moment.locale('nl');

const weeks = _.map(_.range(-52, 1), (week) => ({
    start: moment().startOf('week').add(week, 'weeks').format('DD-MM-YYYY'),
    end: moment().endOf('week').add(week, 'weeks').format('DD-MM-YYYY'),
    number: moment().startOf('week').add(week, 'weeks').week(),
    year: moment().startOf('week').add(week, 'weeks').format('YYYY'),
}));

const ExportOvertimes = ({t}) => {
    const [loading, setLoading] = useState(false);
    const [week, setWeek] = useState({
        start: moment().startOf('week').format('DD-MM-YYYY'),
        end: moment().endOf('week').format('DD-MM-YYYY'),
        number: moment().startOf('week').week(),
        year: moment().startOf('week').format('YYYY'),
    });

    const downloadOvertimeFile = () => {
        setLoading(true);

        downloadOvertime(week.start, week.end)
            .then((res) => {
                let extension = 'xlsx';
                let tempFileName = `cse-export-weekendhours-totalen-van-${week.start}-tot-${week.end}`;
                let fileName = `${tempFileName}.${extension}`;

                const blob = new Blob([res.data], {
                    type: 'application/octet-stream',
                });
                saveAs(blob, fileName);
            })
            .catch((e) => {
                errorHandler(e.response.data, true, t);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <StackedSpacer space="md">
            <Card color="primary">
                <h3>{t('explanations.DownloadWeekendHours')}</h3>
                <br />
                <LineSpacer space="sm">
                    <FormSelect
                        defaultValue={week.start}
                        label={t('general.SelectWeek')}
                        onChange={(evt) => setWeek(weeks.find((week) => week.start == evt.target.value))}
                    >
                        {weeks.map((week) => {
                            return (
                                <option value={week.start} key={week.start}>
                                    Week {week.number} : {week.start} tot {week.end}
                                </option>
                            );
                        })}
                    </FormSelect>
                </LineSpacer>
            </Card>
            <LineSpacer space="sm">
                {!loading && (
                    <Btn type="button" color="success" onClick={() => downloadOvertimeFile()} disabled={loading}>
                        {loading ? t('general.Busy') : t('general.Generate')}
                    </Btn>
                )}
            </LineSpacer>
        </StackedSpacer>
    );
};
export default withTranslation()(ExportOvertimes);
